import { Stack, styled, Typography, useTheme } from '@mui/material';
import { FormatCurrency } from '../../utils/numbers';
import Spinner from '../Spinner';

const TotalWalletContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  textAlign: 'center',
  padding: '0px',
  [theme.breakpoints.up('sm')]: {
    padding: '0px 10px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '0px 22px',
  },
}));

const TotalAmount = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
}));

const Amount = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.darkBlue,
  fontWeight: 'bold',
  fontSize: 'clamp(1.25rem, 2vw, 2rem)',
}));

export const TotalWallet = ({ balance, loadingBalance, errorBalance, title = 'Total en Caja' }) => {
  if (loadingBalance) {
    return <Spinner />;
  }

  if (errorBalance) {
    throw new Error('Error component my wallet');
  }

  return (
    <TotalWalletContainer>
      <TotalAmount>{title}</TotalAmount>
      <Amount>{FormatCurrency(balance)}</Amount>
    </TotalWalletContainer>
  );
};
